import { useEffect, useState } from 'react';

/** Loads only metadata for a video URL and returns duration in seconds when available. */
export function useVideoDurationSeconds(url: string | undefined): number | undefined {
  const [duration, setDuration] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (!url) {
      setDuration(undefined);
      return;
    }

    let cancelled = false;
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.muted = true;
    video.playsInline = true;

    const onLoadedMetadata = () => {
      if (cancelled) {
        return;
      }
      const next = video.duration;
      setDuration(Number.isFinite(next) && next > 0 ? next : undefined);
    };

    const onError = () => {
      if (!cancelled) {
        setDuration(undefined);
      }
    };

    video.addEventListener('loadedmetadata', onLoadedMetadata);
    video.addEventListener('error', onError);
    video.src = url;

    return () => {
      cancelled = true;
      video.removeEventListener('loadedmetadata', onLoadedMetadata);
      video.removeEventListener('error', onError);
      video.removeAttribute('src');
      video.load();
    };
  }, [url]);

  return duration;
}
